import classNames from "classnames"
import { twMerge } from "tailwind-merge"

type QuoteItemProps = {
  value: string | number | React.ReactElement
  label: string | React.ReactElement
  secondaryLabel?: React.ReactNode
  secondaryValue?: React.ReactNode
  bold?: boolean
  isCategory?: boolean
  isDeductable?: boolean
  dataTestId?: string
} & React.HTMLAttributes<HTMLLIElement>

export function QuoteItem({
  value,
  label,
  secondaryLabel,
  secondaryValue,
  bold,
  className,
  isCategory,
  isDeductable,
  dataTestId,
  ...rest
}: QuoteItemProps) {
  const cn = twMerge(
    classNames("flex justify-between rounded-md items-center", {
      "font-semibold": bold,
      "mb-2": !className?.includes("mb"),
      "py-1": !className?.includes("py"),
    }),
    className,
  )

  // If value is a ReactElement this should be empty in order to render only the value
  const currencyAndAmount = typeof value === "string" ? String(value)?.split(" ") : ""

  const currency = currencyAndAmount[0]
  const amount = currencyAndAmount[1]

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <li className={cn} {...rest}>
      <div className="w-full flex-1">
        {label}
        {secondaryLabel && <div className="text-sm text-gray-400">{secondaryLabel}</div>}
      </div>
      <div className="ml-4 flex-initial">
        {isCategory && currencyAndAmount ? (
          <div className="text-sm" data-testid={`quote-item-${currency}-${amount}`}>
            {isDeductable && <span>(</span>}
            <span className="font-semibold">{currency}</span>
            <span className="ml-1" data-testid={dataTestId}>
              {amount}
            </span>
            {secondaryValue && (
              <div className="text-right text-sm text-gray-400">{secondaryValue}</div>
            )}
            {isDeductable && <span>)</span>}
          </div>
        ) : (
          <span data-testid={dataTestId}>{value}</span>
        )}
      </div>
    </li>
  )
}
